import { getBalance, selectUserId } from 'containers/Login/loginSlice'
import { getWarehouses } from 'containers/Warehouses/warehousesSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import useTranslation from 'hooks/useTranslation'
import { useLocation } from 'react-router-dom'
import { ACCOUNT_TYPE } from '../accountSlice'
import Payments from 'components/Payments'
import InvoicesList from './List'
import { useState } from 'react'

export const type = ACCOUNT_TYPE.invoices

const Invoices = ({ onlyBody = false, needPayment = false, customWrapperClassName = '' }) => {
  const [invoicesToPay, setInvoicesToPay] = useState({})
  const userId = useReduxSelector(selectUserId)
  const [page, setPage] = useState('invoices')
  const { pathname } = useLocation()

  const amount = Object.values(invoicesToPay).reduce((r, e) => r += Number(e), 0)

  const dispatch = useReduxDispatch()
  const { t } = useTranslation('account')

  switch (page) {
    case 'payments': {
      const invoices = Object.entries(invoicesToPay).map(([invoiceId, amount]) => ({ invoiceId, amount }))
      const invoiceIds = Object.keys(invoicesToPay)
      return <Payments
        grossPrice={amount}
        invoiceIds={invoiceIds}
        returnPath={pathname}
        summaryTop={t('numberOfInvoices')}
        getInvoices={() => invoices}
        summaryBottom={invoices.length}
        close={(remotePaymentId) => {
          if (remotePaymentId) {
            if (needPayment) dispatch(getWarehouses(userId))
            dispatch(getBalance())
            setInvoicesToPay({})
          }
          setPage('invoices')
        }}
      />
    }

    default: {
      const list = <InvoicesList
        amount={amount}
        invoicesToPay={invoicesToPay}
        customWrapperClassName={customWrapperClassName}
        setInvoicesToPay={setInvoicesToPay}
        showPayments={() => {
          setPage('payments')
        }}
      />

      return onlyBody
        ? list
        : <div className='account__safety'>
          <div className='account__header title'>
            <div>{t('invoices')}</div>
            <div>{t('subTitle')}</div>
          </div>
          {list}
        </div>
    }
  }
}

export default Invoices